export default {
  创建邮件模板: 'Create Email Templates',
  邮件邀约提示1:
    'Email invitation template not more than 10M, picture size is recommended not more than 5M, email invitation cost 1 point/email, when sending emails, the system will pre-freeze the corresponding SMS points according to the emails sent, after the emails are sent, according to the number of successful delivery to be deducted, failure will return the corresponding points.',
  邮件邀约提示2_0: 'Tip:',
  邮件邀约提示2_1:
    '1、“Pre-send effect detection”: Before sending, you can predict the acceptance of the email template by major email service providers, so that customers can improve and optimize the template, protecting customer investment;',
  邮件邀约提示2_2:
    '2、Deduction type: If the email size is within 100KB, 1 point will be deducted. If it exceeds 100KB, it will be deducted according to "email size / 100KB". The part less than 100KB is calculated as 100KB; for example, 130KB deducts 2 points, 280KB deducts 3 points;',
  邮件邀约提示2_3:
    '3、All templates "send test" is allowed to test 10 times a day, each time allows 2 emails; red templates are not allowed to test, not allowed to send;',
  邮件邀约提示2_4:
    '4、The email size displayed above is the size after the email is packaged, including the email header/statistics code;',
  邮件邀约提示2_5:
    '5、“Send test” does not process variables in the email; if the email template is red, the send test is disabled;',
  再发一条: 'Send another',
  实际触达客户数: 'Actual Reaching Customers',
  预计触达客户数: 'Expected Reach Customers',
  转入点数: 'Transfer in points',
  转入: 'Switch to',
  邀约点数: 'Invitation points',
  可分配邀约点数余量: 'Allocable invitation point balance',
  邀约点数分配: 'Invitation point allocation',
  分配点数: 'Distribution Points',
  模版内容: 'Template content',
  模板类型: 'Template Type',
  官方平台: 'Cloud Momentum',
  短信: 'Text',
  渠道来源: 'Channel of invitation',
  访问者: 'Visitors',
  更多客户数据追踪: 'Track more clients’ data',
  短链接访问人数: 'Number of visitors',
  短链接访问量: 'Visits',
  短链接ID: 'Short link ID',
  邀约记录ID: 'Invitation Record ID',
  效果详情: 'Effect',
  发送邀约: 'Send invitations',
  短信类型: 'Type of the text',
  我的名片短链接: 'Short link of my cloud exhibition system',
  个人云展预览: 'Preview',
  实现人脉裂变: 'Access to More Potential Partners',
  一键分享云展: 'Share My Cloud Exhibition',
  自定义短链接: 'Custom short link',
  参加的展览: 'Attended Exhibition',
  精准邀约提示33: '4、SMS is currently available only for domestic numbers.',
  精准邀约提示32:
    '3、Standard invitation SMS costs 1 point per message. Multimedia invitation SMS costs 3 points per message. The points are deducted after the messages were sent. If there are failed messages, the system will return the corresponding points.',
  精准邀约提示31:
    '2、Document Size Limits:The template of the Multimedia SMS should be no more than 1.9M. Video should be no more than 50M. (Preferable Duration: within 33 seconds; Preferable Landscape Video Resolution: 1920*1080px; Preferable Portrait Image Resolution: 1080*1920px). The system will automatically compress the video files.The recommended image size is between 50KB to 1.8M (Preferable Landscape Image Resolution: 1920*1080px; Preferable Portrait Image Resolution: 962*1300px).\n',
  精准邀约提示30:
    '1、Standard invitation SMS (text only) is limited to 70 characters, including punctuation, number, Chinese character, and letter. If your message is longer than that, each extended 67 characters cost extra 1 point.',

  访问人数: 'Visits',
  点击次数: 'Clicks',
  掀起采购狂潮: 'Cause a purchasing frenzy.',
  了解企业实况: 'Know the Enterprise',
  '多样化邀约形式获取海量客源,引爆客户流量': 'Acquire a large number of clients by different invitation types.',
  '亿级企业客户数据,一键发送短信精准邀约潜在客户': 'Acquire a large number of clients by different invitation types.',
  普通邀约: 'Standard Invitation',
  多媒体邀约: 'Multimedia Invitation',
  //
  压缩失败: 'Compression failed',
  超出最大大小: 'Over the size limit',
  插入变量: 'Insert information',
  精准邀约提示29: 'Partial import failed for format error',
  导入成功: 'Imported',
  下载批量导入模板: 'Download batch import templates',
  批量导入: 'Batch import',
  导入客户库群组: 'Import customer database groups',
  导入客户库手机号: 'Import customer database phone',
  导入云数据: 'Import cloud data',
  请添加: 'Add',
  确定要全部清空吗: 'Are you sure you want to delete all?',
  个手机号: 'phone number',
  定时发送: 'Schedule a transmission',
  重选模版: 'Change the template',
  选择模版: 'Select template',
  请选择模板: 'Choose a template',
  通讯录群组: 'Contact groups',
  个群组: 'group(s)',
  个客户群组: 'customer group(s)',
  查询: 'Search',
  重置: 'Reset',
  选择手机号: 'Choose phone number',
  精准邀约提示28: 'Please invite buyers after publishing your company’s purchasing！',
  精准邀约提示27: 'Please invite buyers after publishing your company’s purchasing！',
  精准邀约提示26: 'Please invite buyers after registering to attend the exhibition！',
  精准邀约提示25: 'Please invite buyers after creating a live stream！',
  精准邀约提示24:
    'Please invite buyers after contacting the enterprise account you are affiliated with to create your company’s 3D content！',
  精准邀约提示23: 'Please invite buyers after creating your business card！',
  精准邀约提示22:
    'Your company hasn’t added any coupons. Please contact the enterprise account you are affiliated with to add coupons！',
  精准邀约提示21: 'Your company hasn’t post any exhibit. Please invite buyers after posting at least an exhibit！',
  去发布: 'Go to post',
  去参展: 'Go to register for the exhibition',
  去创建: 'Go to create',
  邀约提示: 'Notes of invitation',
  至少选择一个数据: 'Choose at least an item',
  选择: 'Choose',
  短信签名: 'SMS signature',
  模板详情: 'Details of the template',
  请: 'Please',
  当前账户余额不足: 'There is not enough money in the account',
  '金币/点': 'coins/point',
  短信购买: 'Purchase by SMS',
  模版ID: 'ID template',
  营销短信类型: 'Type of marketing SMS',
  精准邀约提示20: '2、New custom templates need to be reviewed before sending；',
  精准邀约提示19:
    '1、Standard invitation SMS costs 1 point per message. Multimedia invitation SMS costs 3 points per message；',
  云数据库: 'Cloud data storage',
  预计触达人数: 'Expected number of recipients',
  预计消耗短信: 'Expected number of messages',
  计划状态: 'Status',
  发送计划: 'Plan',
  选择模板: 'Choose a template',
  云数据精准邀约: 'Cloud data accurate invitation',
  选择邀约场景: 'Choose invitation scenario',
  掀起起采购狂潮: 'Cause a purchasing frenzy',
  发布优惠券: 'Add coupons',
  海量供应商报价: 'Quotes from a large number of suppliers',
  发布采购需求: 'Publish buyers’ requirements',
  打造百万流量: 'Invite a large number of buyers to visit the exhibition',
  发送展会邀请函: 'Send exhibition invitation',
  观众实时互动: 'Real-time audience interactions',
  分享直播: 'Share the live stream',
  参观企业实况: 'Visit the enterprise',
  邀请全球客户: 'Invite global clients',
  品牌曝光营销: 'Brand marketing',
  产品上新通知: 'Products launch announcement',
  领现金红包: 'Get cash rewards',
  邀请好友注册: 'Invite friends to register',
  邀请好友: 'Invite friends',
  参观云展系统: 'Visit cloud exhibition system',
  邀请全球采购商: 'Invite global buyers',

  立即邀约: 'Invite immediately',
  提交发送: 'Send',
  发送时间: 'Send time',
  发送的模版: 'Chosen template',
  邀约内容: 'Content of the invitation',
  发送手机不能为空: 'Phone number cannot be empty',
  发送手机: 'Phone number',
  精准邀约提示18:
    'Please enter an 11-digit phone number (accepted China phone numbers only). Press Enter key to confirm',
  发送主题最多输入10个字符: 'Character limit: 10 characters',
  发送主题不能为空: 'Subject cannot be empty',
  精准邀约提示17: 'Used as a message remark only；',
  邀约对象: 'Invitees',
  更多信息: 'More information',
  提交审核: 'Submit',
  条短信收费: 'pieces of SMS charge',
  按: 'as',
  字符: 'characters',
  约: 'about',
  当前已输入: 'has been entered',
  短信效果预览: 'Preview the message',
  备注最多输入20个字符: 'Character limit: 20 characters',
  精准邀约提示16:
    '1、It can be used to briefly record the specific purpose of the current template, such as customer birthday',
  审核要求最多输入50个字符: 'Character limit: 50 characters',
  精准邀约提示15:
    '1、You can describe your audit requirements or expectations here. For example, hope that the template only needs China Mobile review, China Unicom and China Telecom do not need review; or hope to complete the review within 2 hours. If you do not require, the China Mobile, China Unicom and China Telecom all need review',
  精准邀约提示14: 'Maximum size: 10M. MP4/3GP formats are accepted. Preferably MP4 format, within 33 seconds.',
  精准邀约提示13:
    '2、In order to ensure the file size of RCS is within 1.9M, it is recommended that the size of the picture are below 1.5M',
  精准邀约提示12:
    '1、PNG/JPG/JPEG/GIF formats are accepted. Preferable Landscape Image Resolution: 1920*1080px; Preferable Portrait Image Resolution: 962*1300px; Maximum Height: 3000px；',
  模板正文不能为空: 'Template text content cannot be empty.',
  精准邀约提示11: '3、The message template can only insert one short link (except coupons).',
  精准邀约提示10:
    '2、The short link of the Company Page/Business Card is the link of your company page/your business card！',
  精准邀约提示9:
    '	1.	Messages containing up to 70 characters (inclusive) are counted as 1 SMS.\n 2.	Messages with 71-134 characters are counted as 2 SMS.\n 3.	For messages exceeding 134 characters, every additional 67 characters will count as 1 additional SMS.\n 4.	Punctuation marks, numbers, letters, and Chinese characters are all counted as 1 character (SMS signatures and “Reply R to unsubscribe” are also included in the character count). A maximum of 1,000 characters is allowed.',
  精准邀约提示8:
    '4、Post-ending content such as free streaming, unsubscription, etc. is automatically added by the system, and the template cannot contain post-ending words；',
  精准邀约提示7: '3、The template body cannot contain special characters, such as 【】、[ ], etc；',
  精准邀约提示6: '2、According to the mobile service provider’s requirement, the size limit of one template is 1.9M；',
  精准邀约提示5:
    '1、The template must include text. It does not allow pure text, pure picture, pure audio, or pure video files；',
  自定义模版: 'Custom templates',
  官方模版: 'Official templates',
  精准邀约提示4: '4、SMS, RCS accepts China phone numbers only (excluding Hong Kong, Taiwan, and Macau).；',
  精准邀约提示3:
    '3、Standard invitation SMS costs 1 point per message. Multimedia invitation SMS costs 3 points per message. The points are deducted after the messages were sent. If there are failed messages, the system will return the corresponding points；',
  精准邀约提示2:
    '2、Document Size Limits: The template of the Multimedia SMS should be no more than 1.9M. Video should be no more than 50M. (Preferable Duration: within 33 seconds; Preferable Landscape Video Resolution: 1920*1080px; Preferable Portrait Image Resolution: 1080*1920px). The system will automatically compress the video files. The recommended image size is between 50KB to 1.8M (Preferable Landscape Image Resolution: 1920*1080px; Preferable Portrait Image Resolution: 962*1300px)\n;',
  精准邀约提示1:
    '1、1. Standard invitation SMS (text only) is limited to 70 characters, including SMS signature, punctuation, numbers, Chinese characters, and letters. If your message is longer than that, each extended 67 characters cost extra 1 point。',
  系统取消发送: 'The sending was canceled by the system',
  用户取消发送: 'The sending was canceled by the user',
  好友邀约: 'Invite friends',
  我参展的展览: 'Attended exhibition',
  其他: 'Others',
  多媒体: 'Multimedia',
  普通: 'Ordinary',
  短链接: 'Short Link',
  取消成功: 'Canceled',
  发送状态: 'Status of sending',
  模板: 'Template',
  邀约模板类型: 'Types of invitation template',
  开始发送时间: 'Send time',
  发送主题: 'Send Subject',
  取消计划: 'Cancel',
  确定要取消吗: 'Are you sure you want to cancel it?',
  发送明细: 'Sending Details',
  邀约计划列表: 'Invitation to-do list',
  邀约场景推荐: 'Invitation scenarios recommendation',
  发多媒体邀约: 'Send multimedia invitation',
  '平台提供海量精准大数据客户群,助力企业更高效找到潜在的客户':
    'Cloud Momentum help enterprises acquire a large number of potential clients effectively',
  云展动力精准邀约服务使用协议: 'Cloud Momentum Accurate Invitation - Terms of Service',
  立即充值即表示同意: 'By topping up, you’re agreeing to the Terms',
  可用点数: 'Available points',
  赠送点数就是送你的点数: 'Gift points are points that are sent to you',
  赠送点数: 'Bonus Points',
  邀约点数余量: 'Remained points of invitation',
  邀约模板: 'Templates of invitation',
  邀约效果: 'Effects of invitation',
  邀约记录: 'Records of invitation',
  邀约管理: 'Invitation management',
  邀约任务: 'Invitation tasks',
}
